export default __webpack_public_path__ + "static/media/remindMe_thumbnail.9c898680.png";